var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"tool",attrs:{"id":"layer-info"}},[_c('Pie',{attrs:{"data":_vm.data,"layout":_vm.layout,"donutThickness":10}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }